import { render } from "./MySQLIcon.vue?vue&type=template&id=fb8a3054&scoped=true"
import script from "./MySQLIcon.vue?vue&type=script&lang=js"
export * from "./MySQLIcon.vue?vue&type=script&lang=js"

import "./MySQLIcon.vue?vue&type=style&index=0&id=fb8a3054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8a3054"]])

export default __exports__